export default __webpack_public_path__ + "static/media/solution.e6d8c5a4.png";